(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("forge"), require("localforage"));
	else if(typeof define === 'function' && define.amd)
		define(["forge", "localforage"], factory);
	else if(typeof exports === 'object')
		exports["ca"] = factory(require("forge"), require("localforage"));
	else
		root["ca"] = factory(root["forge"], root["localforage"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_1__, __WEBPACK_EXTERNAL_MODULE_3__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var forge = __webpack_require__(1);
var LocalForageStorage_1 = __webpack_require__(2);
exports.Storage = LocalForageStorage_1.default;
var pki = forge.pki, util = forge.util, asn1 = forge.asn1, pkcs12 = forge.pkcs12;
var Algorithm;
(function (Algorithm) {
    Algorithm["SHA256"] = "sha256";
    Algorithm["SHA384"] = "sha384";
    Algorithm["SHA512"] = "sha512";
})(Algorithm = exports.Algorithm || (exports.Algorithm = {}));
/**
 * Class has functions to upload and download a certificate to and from
 * browser storage as well as perform document signing
 *
 * @export
 * @class CertificateUtils
 */
var CertificateUtils = (function () {
    /**
     * Creates an instance of CertificateUtils.
     *
     * @param {(IStorage | string)} storageOrName - the name of the underlying browser storage
     * to create or a object that implements the IStorage interface
     * @param {string} certStoreKey - the key to use when adding a certificate to storage.
     * Id of user to which to certificate belongs, will be appended to this value to create
     * the final key
     *
     * @memberOf CertificateUtils
     */
    function CertificateUtils(storageOrName, certStoreKey) {
        if (!storageOrName) {
            throw new Error('Either the storage name or an an object that implements IStorage instance must be specified');
        }
        if (!certStoreKey) {
            throw new Error('The store key must be specified');
        }
        if (typeof storageOrName === 'string') {
            this.storage = new LocalForageStorage_1.default(storageOrName);
        }
        else {
            this.storage = storageOrName;
        }
        this.certStoreKey = certStoreKey;
    }
    /**
     * Stores a certificate file in the browser storage
     *
     * @param {File} file - The PKCS12 file uploaded via a file input element
     * @param {string} userId - the id of the user to which the certificate belongs
     * @returns {Promise<Uint8Array>} - A promise of the certificate file as an Uint8Array
     *
     * @memberOf CertificateUtils
     */
    CertificateUtils.prototype.storePkcs12File = function (file, userId) {
        var _this = this;
        if (!file) {
            return Promise.reject('The certificate file must be specified');
        }
        if (!userId) {
            return Promise.reject('The user ID must be specified');
        }
        return new Promise(function (resolve, reject) {
            var p12FileReader = new FileReader();
            /**
             * Handler that saved the uploaded file to the browser's storage
             *
             * @param {any} event
             */
            p12FileReader.onload = function (event) {
                var p12File = new Uint8Array(event.target.result);
                _this.storage
                    .set(_this.getStoreKey(userId), p12File)
                    .then(function (_) { return resolve(p12File); });
            };
            p12FileReader.readAsArrayBuffer(file);
        });
    };
    /**
     * Determines if a PKCS12 file belonging to a user is stored in browser storage
     *
     * @param {string} userId - the id of the user to which the certificate belongs
     * @returns {Promise<boolean>} - A promise of the boolean value. True if stored, otherwise false.
     *
     * @memberOf CertificateUtils
     */
    CertificateUtils.prototype.isPkcs12FileStored = function (userId) {
        return __awaiter(this, void 0, void 0, function () {
            var p12File;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!userId) {
                            return [2 /*return*/, Promise.reject('The user ID must be specified')];
                        }
                        return [4 /*yield*/, this.getPkcs12FileFromStore(userId)];
                    case 1:
                        p12File = _a.sent();
                        return [2 /*return*/, !!p12File];
                }
            });
        });
    };
    /**
     * Downloads a PKCS12 file from browser storage
     *
     * @param {string} userId - the id of the user to which the certificate belongs
     * @param {string} fileName - the name to give the downloaded certificate file.
     * Defaults to the userId
     * @param {string} extension - The file extension. Defaults to 'pfx'
     *
     * @memberOf CertificateUtils
     */
    CertificateUtils.prototype.downloadPkcs12File = function (userId, fileName, extension) {
        if (extension === void 0) { extension = 'pfx'; }
        return __awaiter(this, void 0, void 0, function () {
            var p12File, certFileBlob, url, pfxFileName, a;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!userId) {
                            throw new Error('The user ID must be specified');
                        }
                        fileName = fileName || userId;
                        return [4 /*yield*/, this.getPkcs12FileFromStore(userId)];
                    case 1:
                        p12File = _a.sent();
                        certFileBlob = new Blob([p12File]);
                        url = URL.createObjectURL(certFileBlob);
                        pfxFileName = fileName + "." + extension;
                        a = document.createElement('a');
                        document.body.appendChild(a);
                        a.style.display = 'none';
                        a.href = url;
                        a.setAttribute('download', pfxFileName);
                        a.click();
                        URL.revokeObjectURL(url);
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Signs the given document
     *
     * @param {(Uint8Array | string)} doc - The file byte array or string
     * @param {string} userId - The id of the user to which the certificate belongs
     * @param {string} privateKeyPassword - The password for the private key associated with the certificate
     * @param {SignatureType} [signatureType=SignatureType.CAdES]  - Whether or not to wrap the signature in a PKCS#7
     * message format
     * @param {Date} timeStamp - The date that will be embedded in the PKCS#7/CMS message or a timestamp token
     * from a TimeStamp server to be added to the CAdES message
     * @param {Algorithm} [algorithm=Algorithm.SHA512]  - The message digest algorithm. Default is sha512
     * @returns {Promise<string>} - A promise of the signed document value.
     * @memberOf CertificateUtils
     */
    CertificateUtils.prototype.signDocument = function (doc, userId, privateKeyPassword, timeStamp, algorithm) {
        if (algorithm === void 0) { algorithm = Algorithm.SHA512; }
        return __awaiter(this, void 0, void 0, function () {
            var p12File, _a, key, cert;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!doc) {
                            Promise.reject('The document to sign must be specified');
                        }
                        if (!userId) {
                            Promise.reject('The user ID must be specified');
                        }
                        if (!privateKeyPassword) {
                            Promise.reject('Certificate password must be specified');
                        }
                        return [4 /*yield*/, this.getPkcs12FileFromStore(userId)];
                    case 1:
                        p12File = _b.sent();
                        if (!p12File) {
                            throw new Error("No certificate found for user ID: " + userId);
                        }
                        _a = this.getPrivateKeyAndCert(p12File, privateKeyPassword), key = _a.key, cert = _a.cert;
                        if (!(doc instanceof Uint8Array || typeof doc === 'string')) {
                            throw new Error('The document to sign must be a string or a Uint8Array');
                        }
                        return [2 /*return*/, this.getCAdESSignedPackage(doc, cert, key, algorithm, timeStamp)];
                }
            });
        });
    };
    /**
     * Signs a PDF document and embeds the signature
     *
     *
     * @memberOf CertificateUtils
     */
    CertificateUtils.prototype.signPdf = function () {
        throw new Error('signPdf is not yet implemented');
        // TODO: Call PDFSign to sign the document
        // TODO:
        // 1. Patch pdfsign.js (pdfsign-patched-dci.js) to call a custom signDetached function
        //    instead of the patched function from forge-patched.js file
        // 2. Create signedDetachedFunction to take a 'msg' parameter that has the same functionality
        //    as https://github.com/digitalbazaar/forge/blob/master/lib/pkcs7.js#L330 but patched as in
        //    https://github.com/Communication-Systems-Group/pdfsign.js/blob/master/src/lib/pkcs7-detached.js#L350
        // 3. Call PDFSign to sign document. See sample in samples/pdf-sign.html
    };
    /**
     * Gets the certificate from the store
     *
     * @param {string} userId - The id of the user to which the certificate belongs
     * @returns - The certificate file bytes
     *
     * @memberOf CertificateUtils
     */
    CertificateUtils.prototype.getPkcs12FileFromStore = function (userId) {
        return this.storage.get(this.getStoreKey(userId));
    };
    CertificateUtils.prototype.getCAdESSignedPackage = function (data, cert, privateKey, algorithm, timeStamp) {
        return this.createCmsSignedPackage(data, cert, privateKey, algorithm, timeStamp);
    };
    CertificateUtils.prototype.createCmsSignedPackage = function (data, cert, privateKey, algorithm, timeStamp) {
        var privateKeyPem = pki.privateKeyToPem(privateKey);
        var certPem = pki.certificateToPem(cert);
        var signedAttr = { SigningCertificateV2: { array: [certPem] } };
        signedAttr.SigningTime = timeStamp
            ? { str: this.toDateString(timeStamp) }
            : {};
        var cms = KJUR.asn1.cms.CMSUtil.newSignedData({
            content: data instanceof Uint8Array
                ? { hex: util.binary.hex.encode(data) }
                : { str: data },
            certs: [certPem],
            signerInfos: [
                {
                    hashAlg: algorithm,
                    sAttr: signedAttr,
                    signerCert: certPem,
                    sigAlg: algorithm.toUpperCase() + "withRSA",
                    signerPrvKey: privateKeyPem
                }
            ]
        });
        var cmsHex = cms.getContentInfoEncodedHex();
        return util.binary.base64.encode(util.binary.hex.decode(cmsHex));
    };
    CertificateUtils.prototype.getPrivateKeyAndCert = function (p12File, certPassword) {
        // create forge byte bugger
        var buffer = new util.ByteBuffer(p12File.buffer);
        // get forge cert from byte buffer
        var p12Asn1 = asn1.fromDer(buffer);
        // decrypt p12 using non-strict parsing mode (resolves some ASN.1 parse errors)
        var p12Cert = pkcs12.pkcs12FromAsn1(p12Asn1, false, certPassword);
        // get key bags
        var keyBags = p12Cert.getBags({ bagType: pki.oids.pkcs8ShroudedKeyBag });
        // get key
        var keyBag = keyBags[pki.oids.pkcs8ShroudedKeyBag][0];
        if (!keyBag) {
            throw new Error('PKCS12 file does not contain a private key');
        }
        var key = keyBag.key;
        // if the key is in a format unrecognized by forge then
        // bag.key will be `null`, use bag.asn1 to get the ASN.1
        // representation of the key
        if (key === null) {
            var keyAsn1 = keyBag.asn1;
            key = pki.privateKeyFromAsn1(keyAsn1);
            if (!key) {
                throw new Error('Unable to read key stored in PKCS12 file');
            }
        }
        // get cert bags
        var certBags = p12Cert.getBags({ bagType: pki.oids.certBag });
        // get cert
        var certBag = certBags[pki.oids.certBag][0];
        if (!certBag) {
            throw new Error('PKCS12 file does not contain a certificate');
        }
        if (!certBag.cert) {
            throw new Error('Unable to read certificate stored in PKCS12 file');
        }
        var cert = certBag.cert;
        return { key: key, cert: cert };
    };
    CertificateUtils.prototype.getStoreKey = function (userId) {
        return this.certStoreKey + "_" + userId;
    };
    CertificateUtils.prototype.toDateString = function (date) {
        var year = date.getUTCFullYear().toString().substr(2);
        var month = (date.getUTCMonth() + 1).toString();
        if (month.length === 1) {
            month = '0' + month;
        }
        var day = date.getUTCDate().toPrecision();
        if (day.length === 1) {
            day = '0' + day;
        }
        var hour = date.getUTCHours().toString();
        if (hour.length === 1) {
            hour = '0' + hour;
        }
        var min = date.getUTCMinutes().toString();
        if (min.length === 1) {
            min = '0' + min;
        }
        var sec = date.getUTCSeconds().toString();
        if (sec.length === 1) {
            sec = '0' + sec;
        }
        return year + month + day + hour + min + sec + 'Z';
    };
    return CertificateUtils;
}());
exports.CertificateUtils = CertificateUtils;


/***/ }),
/* 1 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_1__;

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var localforage = __webpack_require__(3);
/**
 * The browser storage class
 *
 * @export
 * @class Storage
 */
var LocalForageStorage = (function () {
    /**
     * Creates an instance of Storage.
     *
     * @param {string} name
     *
     * @memberOf Storage
     */
    function LocalForageStorage(name) {
        this.name = name;
        localforage.config({
            name: name
        });
    }
    /**
     * Removes an item with the given key from storage
     *
     * @param {string} key
     * @returns {Promise<void>}
     *
     * @memberOf Storage
     */
    LocalForageStorage.prototype.remove = function (key) {
        return localforage.removeItem("" + key);
    };
    /**
     * Sets the value of an item in storage based on the given key
     *
     * @template TValue
     * @param {string} key
     * @param {TValue} item
     * @returns {Promise<TValue>}
     *
     * @memberOf Storage
     */
    LocalForageStorage.prototype.set = function (key, item) {
        return localforage.setItem("" + key, item);
    };
    /**
     * Gets the item with the given key from storage
     *
     * @template TValue
     * @param {string} key
     * @returns {Promise<TValue>}
     *
     * @memberOf Storage
     */
    LocalForageStorage.prototype.get = function (key) {
        return localforage.getItem("" + key);
    };
    return LocalForageStorage;
}());
exports.default = LocalForageStorage;


/***/ }),
/* 3 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_3__;

/***/ })
/******/ ]);
});


// WEBPACK FOOTER //
// ca-cert-utils.min.js